import React, { Component, ReactNode } from 'react';
import ErrorBoundaryPage from '../pages/ErrorBoundaryPage';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  private error: Error | null = null;

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.error = error;
    // Log error details for debugging
    try {
      (window as any).__lastError = { error, errorInfo };
    } catch (e) {
      // Silently fail if we can't set window property
    }
  }


  render() {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryPage error={this.error} />
      );
    }

    return this.props.children;
  }
}
